import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import LoadingPlaceholder from './LoadingPlaceholder';
import AppModal from './AppModal'; // Import the AppModal component

const Appwalls = () => {
    const [appDetails, setAppDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedApp, setSelectedApp] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const url = `${site['site_url']}/ajax/tmk.core.php?action=get.Offerwall`;
            try {
                const response = await axios.post(url, {}, { withCredentials: true });
                if (response.data.status === 'success') {
                    const appDetailsArray = Object.values(response.data.data);
                    setAppDetails(appDetailsArray);
                } else {
                    setError('No data available.');
                }
            } catch (error) {
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!loading && appDetails.length > 0) {
            coreTMK.filterByOS(os); 
        }
    }, [loading, appDetails, os]);

    const handleItemClick = (app) => {
        if(data['id']){
            setSelectedApp(app);
            const appModal = new bootstrap.Modal(document.getElementById('appModal'));
            appModal.show();
        }else{
            const signInModal = new bootstrap.Modal(document.getElementById('SigninForm'));
            signInModal.show();
        }
    };

    const generateListItem = (val) => {
        const conversionsText = val.conversions === 0 ? '' : (
            <span>{val.conversions} <i className="bi bi-people" title="Users"></i> earned {val.conversions * val.payout_vc} coins.</span>
        );
        const filter = (val.os && val.os.length > 0) ? `${val.platform} ${val.os.join(" ")}` : `${val.platform} unspecified`;
        const click_url = val.redirect_url;
        const payout_vc = (val.payout_usd * 2000);

        return (
            <li className={`filter ${filter}`} key={val.id} onClick={() => handleItemClick(val)}>
                <div className="item">
                    <div className="imageWrapper">
                        <img src={val.app_icon} alt={val.app_name} className="imaged w64 img-fluid border rounded-md shadow" />
                    </div>
                    <div className="in">
                        <div>
                            <span className="Xtext-truncateX">
                                {val.app_name} &nbsp;
                                <span dangerouslySetInnerHTML={{ __html: coreTSW.formatDateTime('isNew', moment(val.created, 'YYYY-MM-DD HH:mm:ss').valueOf()) }}></span>
                            </span>
                            <div className="text-muted" dangerouslySetInnerHTML={{ __html: coreTMK.payoutTypeToAction(val.payout_type, val) }}></div>
                            <p className="card-text mb-1">
                                <small className="text-muted">{conversionsText}</small>
                            </p>
                            <small className="text-muted" dangerouslySetInnerHTML={{ __html: coreTSW.convertToBadge('platformToLabel', val.platform, val) }}></small>
                        </div>
                        <div className="btn-group" role="group">
                            <a className="btn btn-warning btn-sm btn-block" href={click_url} target="_blank" style={{ width: "100%" }}>
                                <i className="bi bi-plus m-0"></i> {payout_vc} 
                                <span className="d-none d-sm-block">&nbsp;$COIN</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        );
    };

    if (loading) {
        return <LoadingPlaceholder />;
    }
    if (error) {
        return <div>{error}</div>;
    }
    return (
        <>
            <ul id="appDetails" className="listview image-listview media mb-2">
                {appDetails.length > 0 ? appDetails.map(generateListItem) : ''}
            </ul>
            <AppModal selectedApp={selectedApp} />
        </>
    );
};

export default Appwalls;
